var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('home-header'),_vm._v(" "),_c('home-swiper',{attrs:{"list":_vm.swiperList}}),_vm._v(" "),_c('home-icons',{attrs:{"list":_vm.iconList}}),_vm._v(" "),_c('home-recommend',{attrs:{"list":_vm.recommendList}}),_vm._v(" "),_c('home-weekend',{attrs:{"list":_vm.weekendList}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-090079aa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/Home.vue
// module id = null
// module chunks = 